/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Validates a credit card number using the Luhn algorithm.
 */
export const validateCardNumber = (cardNumber: string): boolean => {
    const cleaned = cardNumber.replace(/\D/g, '');
    if (cleaned.length < 13 || cleaned.length > 19) return false;

    let sum = 0;
    let shouldDouble = false;
    for (let i = cleaned.length - 1; i >= 0; i--) {
        let digit = parseInt(cleaned.charAt(i));

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
};

/**
 * Validates card expiry date in MM/YY format.
 */
export const validateExpiry = (expiry: string): boolean => {
    if (!/^\d{2}\/\d{2}$/.test(expiry)) return false;

    const [monthStr, yearStr] = expiry.split('/');
    const month = parseInt(monthStr);
    const year = parseInt(yearStr) + 2000; // Assuming 20xx

    if (month < 1 || month > 12) return false;

    const now = new Date();
    const expiryDate = new Date(year, month, 0); // Last day of that month

    return expiryDate >= now;
};

/**
 * Validates CVV (3 or 4 digits).
 */
export const validateCVV = (cvv: string): boolean => {
    return /^\d{3,4}$/.test(cvv);
};

/**
 * Validates an email address.
 */
export const validateEmail = (email: string): boolean => {
    return /\S+@\S+\.\S+/.test(email);
};

/**
 * Validates a phone number (7 to 20 digits, spaces, hyphens encouraged).
 */
export const validatePhone = (phone: string): boolean => {
    return /^\+?[0-9\s-()]{7,20}$/.test(phone);
};
